import { render, staticRenderFns } from "./FormPFRT.vue?vue&type=template&id=dd1c3a28&scoped=true"
import script from "./FormPFRT.vue?vue&type=script&lang=js"
export * from "./FormPFRT.vue?vue&type=script&lang=js"
import style0 from "./FormPFRT.vue?vue&type=style&index=0&id=dd1c3a28&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1c3a28",
  null
  
)

export default component.exports